import findIndex from 'lodash/findIndex';

const sortAddresses = (addresses) => addresses.sort((a, b) => {
    if (a.default_billing)
        return -1; // Billing address always first
    if (a.default_shipping && b.default_billing)
        return 1; // Billing address goes before Shipping
    if (a.default_shipping)
        return -1; // Shipping address goes before common
    if (b.default_billing || b.default_shipping)
        return 1; // Billing/Shipping address goes before common
    return 0;
});
const processDefaultOptions = (stateItems, item) => {
    const itemDefaultShipping = item.default_shipping;
    const itemDefaultBilling = item.default_billing;
    // If item DefaultShipping and DefaultBilling flags both are not set
    // don't do anything
    if (!itemDefaultShipping && !itemDefaultBilling)
        return stateItems;
    const newItems = [...stateItems]; // make a copy
    const defaultShippingIndex = findIndex(newItems, { default_shipping: true });
    const defaultBillingIndex = findIndex(newItems, { default_billing: true });
    if (defaultShippingIndex !== -1 && item.default_shipping) {
        newItems[defaultShippingIndex].default_shipping = false;
    }
    if (defaultBillingIndex !== -1 && item.default_billing) {
        newItems[defaultBillingIndex].default_billing = false;
    }
    return newItems;
};
const processAfterGet = (stateItems) => sortAddresses(stateItems);
const processAfterCreate = (stateItems, item) => {
    const items = processDefaultOptions(stateItems, item);
    const newItems = [...items, item];
    return sortAddresses(newItems);
};
const processAfterUpdate = (stateItems, item) => {
    const items = processDefaultOptions(stateItems, item);
    const newItems = items.map(currItem => (currItem.id === item.id ? item : currItem));
    return sortAddresses(newItems);
};

export { processAfterCreate, processAfterGet, processAfterUpdate };
//# sourceMappingURL=helper.js.map
